/**
 * @generated SignedSource<<1e659ade99c417d8ef995368b2905b94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedPricingGuidanceSoldLink_item$data = {
  readonly isMultiSku: boolean;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedPricingGuidanceSoldLink_item";
};
export type PdpSharedPricingGuidanceSoldLink_item$key = {
  readonly " $data"?: PdpSharedPricingGuidanceSoldLink_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPricingGuidanceSoldLink_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedPricingGuidanceSoldLink_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMultiSku",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "6936921c58ad93ad436b95d699d0379b";

export default node;
